import React from "react";
import styles from "../ModelSettingsButton/ModelSettingsButton.module.css";
import { ChevronDownIcon } from "../ModelSettingsPopup/modelIcons";

interface LocationSelectorButtonProps {
  onClick: () => void;
  isOpen: boolean;
  selectedSites: string[];
}

const getLabel = (selectedSites: string[]) => {
  if (selectedSites.length === 0 || selectedSites.includes("auto")) {
    return "Location: Auto";
  }

  if (selectedSites.length === 1) {
    return `Location: ${selectedSites[0]}`;
  }

  return `Locations: ${selectedSites.length}`;
};

const LocationSelectorButton = React.forwardRef<
  HTMLButtonElement,
  LocationSelectorButtonProps
>(({ onClick, isOpen, selectedSites }, ref) => (
  <button
    ref={ref}
    onClick={onClick}
    className={`${styles.trigger} ${isOpen ? styles.triggerOpen : ""}`}
    aria-label="Location selector"
    aria-expanded={isOpen}
  >
    <span className={styles.modelName}>{getLabel(selectedSites)}</span>
    <span className={`${styles.chevron} ${isOpen ? styles.chevronFlipped : ""}`}>
      <ChevronDownIcon />
    </span>
  </button>
));

LocationSelectorButton.displayName = "LocationSelectorButton";

export default LocationSelectorButton;
